<template>
    <v-container :fluid="fluid">
      <v-layout row wrap :align-center="boxedLayout" :justify-center="boxedLayout" :fill-height="boxedLayout">
        <!--<v-layout row wrap v-show="!boxedLayout">-->
        <v-flex xs12 sm12 :md12="!boxedLayout" :lg12="!boxedLayout" :md10="boxedLayout" :lg10="boxedLayout">
            <v-card v-show="displayBreadCrumbs">
                <!--<v-card-title style="padding-top:8px;padding-bottom:8px;">-->
                <v-card-title style="padding-top:2px;padding-bottom:2px;">
                <div class="page-header-left"><h3 class="pr-3 title">{{title}}</h3></div>
                <v-spacer></v-spacer>
                  <v-breadcrumbs divider="-" dense>
                    <v-breadcrumbs-item>
                    <v-icon larg>home</v-icon>
                    </v-breadcrumbs-item>
                    <v-breadcrumbs-item v-for="(item,key) in breadcrumbs" :key="key">
                    {{ item }}
                    </v-breadcrumbs-item>
                  </v-breadcrumbs>
                </v-card-title>
            </v-card>
            <v-card v-show="!displayBreadCrumbs">
              <v-card-title>
                <h3 class="pr-3">
                  {{ title }}
                </h3>
                <v-spacer></v-spacer>
                    <v-icon>{{ icon }}</v-icon>
              </v-card-title>
            </v-card>
        </v-flex>
    </v-layout> 
  </v-container> 
</template>

<script>
import menu from '@/helpers/menu';
export default {
    name: 'app-page-header',    
    data () {
        return {
        title: '',
        icon: '',
        routeName: null,
        fluid: false
        };
    },
    
    watch: {

    },

    computed: {
        breadcrumbs: function () {
        let breadcrumbs = [];
        menu.forEach(item => {
            if (item.items) {
            let child =  item.items.find(i => {
                return i.name === this.$route.name;
            })
            if (child) {
                breadcrumbs.push(item.title);
                breadcrumbs.push(child.title);
                this.title = child.title;
                this.icon = child.icon
            } 

            if(item.hasOwnProperty('items')) {
                item.items.forEach(item_item => {
                    if(item_item.hasOwnProperty('items')) {
                        item_item.items.forEach(item_item_item => {
                            if(item_item_item.name === this.$route.name) {
                                breadcrumbs.push(item.title);
                                breadcrumbs.push(item_item.title);
                                breadcrumbs.push(item_item_item.title);
                                this.title = item_item_item.title;
                                this.icon = item_item_item.icon
                                return
                            }
                        })
                    }
                })
            }

            } else {
            if (item.name === this.$route.name) {
                this.title = item.title;
                this.icon = item.icon
                breadcrumbs.push(item.title);
            }
            }
        });
        return breadcrumbs;
        },
        
        displayBreadCrumbs() {
        if(this.$vuetify.breakpoint.mdAndUp) {
            return true;
        }

        return false;
        },

        boxedLayout() {
        
        /*if(this.$store.getters.currentRouteName == 'admin_uredi_profil') {
            return true;
        }

        return false;*/
        console.log()

        switch(this.$store.getters.currentRouteName) {
            case 'add-user':
            return true;
            
            case 'edit-user':
            this.title = 'Uredi uporabnika';
            this.icon = 'account_box'
            return true;

            case 'users-list':
            this.fluid = true
            return false

            default:
            return false  
        }


        }
    },

    methods: {

    },

    created() {
        this.routeName = this.$route.name
    },

    mounted() {

    },

    destroyed() {
        
    }
}
</script>

<style scoped>
    h3 {
        /*font-size: 16px !important;*/
        font-weight: 300 !important;
        letter-spacing: normal !important;
    }
</style>




